import React, { useCallback, useState } from "react";
import Moment from "moment";
import { useMemo } from "react";
import { Messages, DirectboxReceive } from "iconsax-reactjs";
import { useDispatch, useSelector } from "react-redux";
import { meses } from "../../../../../services/data";
import { changeDisplayByeChat } from "../../../../../actions/websocket";
import { deleteEmailMsg } from "../../../../../actions";

export const useSideQueues = (
  arrayChatsWithoutVoice,
  setSelectedChat,
  setMonitorMessage,
  changeDisplayTransfer,
  ViewAnotations,
  setOpenSearch,
  hasVoice,
) => {
  const arrayChats = useMemo(() => {
    if (
      Boolean(hasVoice) &&
      Boolean(
        arrayChatsWithoutVoice.find(
          (chatWithoutVoice) => chatWithoutVoice.idatendimento === "voice",
        ),
      )
    ) {
      return arrayChatsWithoutVoice;
    }
    if (
      !Boolean(hasVoice) &&
      Boolean(
        arrayChatsWithoutVoice.find(
          (chatWithoutVoice) => chatWithoutVoice.idatendimento === "voice",
        ),
      )
    ) {
      return arrayChatsWithoutVoice.filter(
        (chat) => chat.idatendimento !== "voice",
      );
    }
    if (
      Boolean(hasVoice) &&
      !Boolean(
        arrayChatsWithoutVoice.find(
          (chatWithoutVoice) => chatWithoutVoice.idatendimento === "voice",
        ),
      )
    ) {
      return [hasVoice, ...arrayChatsWithoutVoice];
    }
    return arrayChatsWithoutVoice;
  }, [hasVoice, arrayChatsWithoutVoice]);
  const dispatch = useDispatch();
  const infoUsers = useSelector((state) => state.informationusers);
  const messages = useSelector((state) => state.messages);
  const orderByArrival = useCallback((a, b) => {
    let lastDateA = a.datatimeatd;
    let lastDateB = b.datatimeatd;
    const dateObjA = Moment(lastDateA, "DD/MM/YYYY HH:mm:ss");
    const dateObjB = Moment(lastDateB, "DD/MM/YYYY HH:mm:ss");

    // return dateObjA - dateObjB;
    return dateObjA - dateObjB;
  }, []);
  const orderByMessage = useCallback(
    (a, b) => {
      let lastDateA = a.datatimeatd;
      let lastDateB = b.datatimeatd;

      if (messages[a.idatendimento]) {
        const lastMsg = messages[a.idatendimento].at(-1);
        const hasData =
          !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

        if (hasData) {
          lastDateA = lastMsg.dataenvio;
        } else {
          const { dia, anoenvio, datatime } = lastMsg || {};
          if (dia && anoenvio && datatime) {
            const arrDia = dia.split(" ");
            if (Array.isArray(arrDia) && arrDia.length >= 3) {
              const day = arrDia[0];
              const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

              if (monthIndex >= 0 && monthIndex < 12) {
                const month = String(monthIndex + 1).padStart(2, "0");
                const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
                lastDateA = dateString;
              }
            }
          }
        }
      }

      if (messages[b.idatendimento]) {
        const lastMsg = messages[b.idatendimento].at(-1);
        const hasData =
          !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

        if (hasData) {
          lastDateB = lastMsg.dataenvio;
        } else {
          const { dia, anoenvio, datatime } = lastMsg || {};
          if (dia && anoenvio && datatime) {
            const arrDia = dia.split(" ");
            if (Array.isArray(arrDia) && arrDia.length >= 3) {
              const day = arrDia[0];
              const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

              if (monthIndex >= 0 && monthIndex < 12) {
                const month = String(monthIndex + 1).padStart(2, "0");
                const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
                lastDateB = dateString;
              }
            }
          }
        }
      }

      const dateObjA = Moment(lastDateA, "DD/MM/YYYY HH:mm:ss");
      const dateObjB = Moment(lastDateB, "DD/MM/YYYY HH:mm:ss");

      // return dateObjA - dateObjB;
      return dateObjB - dateObjA;
    },
    [messages],
  );
  //chat comum
  const [filterOrderRegularChat, setFilterOrderRegularChat] =
    useState("message");
  const [tabFilterRegularChatSelected, setTabFilterRegularChatSelected] =
    useState("allChats"); // allChats ou unreadedChats
  const regularChats = useMemo(() => {
    if (!Array.isArray(arrayChats)) {
      return [];
    }
    return arrayChats.filter((chat) => !chat.isFromStandby);
  }, [arrayChats]);
  const [textToFilterRegularChats, setTextToFilterRegularChats] = useState("");
  const filteredRegularChats = useMemo(() => {
    const isTextToFilterEmpty = textToFilterRegularChats === "";
    if (
      isTextToFilterEmpty &&
      tabFilterRegularChatSelected === "allChats" &&
      filterOrderRegularChat === "message"
    ) {
      return regularChats.sort(orderByMessage);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterRegularChatSelected === "allChats" &&
      filterOrderRegularChat === "order"
    ) {
      return regularChats.sort(orderByArrival);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterRegularChatSelected === "unreadedChats" &&
      filterOrderRegularChat === "message"
    ) {
      return regularChats
        .filter((regularChat) => Boolean(regularChat.qtdmessage))
        .sort(orderByMessage);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterRegularChatSelected === "unreadedChats" &&
      filterOrderRegularChat === "order"
    ) {
      return regularChats
        .filter((regularChat) => Boolean(regularChat.qtdmessage))
        .sort(orderByArrival);
    }
    if (
      tabFilterRegularChatSelected === "unreadedChats" &&
      filterOrderRegularChat === "message"
    ) {
      return regularChats
        .filter((regularChat) => {
          const isClientNameMatchs =
            typeof regularChat.cliente === "string" &&
            regularChat.cliente
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof regularChat.telefone === "string" &&
            regularChat.telefone
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isSomeMessageMatchs = handleSearchMessages(
            regularChat,
            textToFilterRegularChats,
          );
          return (
            (isClientNameMatchs ||
              isSomeMessageMatchs ||
              isClientTelephoneMatchs) &&
            Boolean(regularChat.qtdmessage)
          );
        })
        .sort(orderByMessage);
    }
    if (
      tabFilterRegularChatSelected === "unreadedChats" &&
      filterOrderRegularChat === "order"
    ) {
      return regularChats
        .filter((regularChat) => {
          const isClientNameMatchs =
            typeof regularChat.cliente === "string" &&
            regularChat.cliente
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof regularChat.telefone === "string" &&
            regularChat.telefone
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isSomeMessageMatchs = handleSearchMessages(
            regularChat,
            textToFilterRegularChats,
          );
          return (
            (isClientNameMatchs ||
              isSomeMessageMatchs ||
              isClientTelephoneMatchs) &&
            Boolean(regularChat.qtdmessage)
          );
        })
        .sort(orderByArrival);
    }
    if (filterOrderRegularChat === "message") {
      return regularChats
        .filter((regularChat) => {
          const isClientNameMatchs =
            typeof regularChat.cliente === "string" &&
            regularChat.cliente
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof regularChat.telefone === "string" &&
            regularChat.telefone
              .toLowerCase()
              .includes(textToFilterRegularChats.toLowerCase());

          const isSomeMessageMatchs = handleSearchMessages(
            regularChat,
            textToFilterRegularChats,
          );
          return (
            isClientNameMatchs || isSomeMessageMatchs || isClientTelephoneMatchs
          );
        })
        .sort(orderByMessage);
    }
    return regularChats
      .filter((regularChat) => {
        const isClientNameMatchs =
          typeof regularChat.cliente === "string" &&
          regularChat.cliente
            .toLowerCase()
            .includes(textToFilterRegularChats.toLowerCase());

        const isClientTelephoneMatchs =
          typeof regularChat.telefone === "string" &&
          regularChat.telefone
            .toLowerCase()
            .includes(textToFilterRegularChats.toLowerCase());

        const isSomeMessageMatchs = handleSearchMessages(
          regularChat,
          textToFilterRegularChats,
        );
        return (
          isClientNameMatchs || isSomeMessageMatchs || isClientTelephoneMatchs
        );
      })
      .sort(orderByArrival);
  }, [
    regularChats,
    textToFilterRegularChats,
    tabFilterRegularChatSelected,
    filterOrderRegularChat,
    orderByMessage,
    orderByArrival,
    handleSearchMessages,
  ]);
  const numberOfRegularChatsWithUnreadedMessages = useMemo(() => {
    return regularChats.filter((regularChat) => Boolean(regularChat.qtdmessage))
      .length;
  }, [regularChats]);
  const [openOrderFilterRegularChats, setOpenOrderFilterRegularChats] =
    useState(false);

  //chat standby
  const [filterOrderStandbyChat, setFilterOrderStandbyChat] =
    useState("message");
  const [tabFilterStandbyChatSelected, setTabFilterStandbyChatSelected] =
    useState("allChats"); // allChats ou unreadedChats
  const standbyChats = useMemo(() => {
    if (!Array.isArray(arrayChats)) {
      return [];
    }
    return arrayChats.filter((chat) => chat.isFromStandby);
  }, [arrayChats]);
  const [textToFilterStandbyChats, setTextToFilterStandbyChats] = useState("");
  const filteredSatndbyChats = useMemo(() => {
    const isTextToFilterEmpty = textToFilterStandbyChats === "";
    if (
      isTextToFilterEmpty &&
      tabFilterStandbyChatSelected === "allChats" &&
      filterOrderStandbyChat === "message"
    ) {
      return standbyChats.sort(orderByMessage);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterStandbyChatSelected === "allChats" &&
      filterOrderStandbyChat === "order"
    ) {
      return standbyChats.sort(orderByArrival);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterStandbyChatSelected === "unreadedChats" &&
      filterOrderStandbyChat === "message"
    ) {
      return standbyChats
        .filter((standbyChat) => Boolean(standbyChat.qtdmessage))
        .sort(orderByMessage);
    }
    if (
      isTextToFilterEmpty &&
      tabFilterStandbyChatSelected === "unreadedChats" &&
      filterOrderStandbyChat === "order"
    ) {
      return standbyChats
        .filter((standbyChat) => Boolean(standbyChat.qtdmessage))
        .sort(orderByMessage);
    }
    if (
      tabFilterStandbyChatSelected === "unreadedChats" &&
      filterOrderStandbyChat === "message"
    ) {
      return standbyChats
        .filter((standbyChat) => {
          const isClientNameMatchs =
            typeof standbyChat.cliente === "string" &&
            standbyChat.cliente
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof standbyChat.telefone === "string" &&
            standbyChat.telefone
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isSomeMessageMatchs = !!handleSearchMessages(
            standbyChat,
            textToFilterStandbyChats,
          );
          return (
            (isClientNameMatchs ||
              isSomeMessageMatchs ||
              isClientTelephoneMatchs) &&
            Boolean(standbyChat.qtdmessage)
          );
        })
        .sort(orderByMessage);
    }
    if (
      tabFilterStandbyChatSelected === "unreadedChats" &&
      filterOrderStandbyChat === "order"
    ) {
      return standbyChats
        .filter((standbyChat) => {
          const isClientNameMatchs =
            typeof standbyChat.cliente === "string" &&
            standbyChat.cliente
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof standbyChat.telefone === "string" &&
            standbyChat.telefone
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isSomeMessageMatchs = !!handleSearchMessages(
            standbyChat,
            textToFilterStandbyChats,
          );
          return (
            (isClientNameMatchs ||
              isSomeMessageMatchs ||
              isClientTelephoneMatchs) &&
            Boolean(standbyChat.qtdmessage)
          );
        })
        .sort(orderByArrival);
    }
    if (filterOrderStandbyChat === "message") {
      return standbyChats
        .filter((standbyChat) => {
          const isClientNameMatchs =
            typeof standbyChat.cliente === "string" &&
            standbyChat.cliente
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isClientTelephoneMatchs =
            typeof standbyChat.telefone === "string" &&
            standbyChat.telefone
              .toLowerCase()
              .includes(textToFilterStandbyChats.toLowerCase());

          const isSomeMessageMatchs = !!handleSearchMessages(
            standbyChat,
            textToFilterStandbyChats,
          );
          return (
            isClientNameMatchs || isSomeMessageMatchs || isClientTelephoneMatchs
          );
        })
        .sort(orderByMessage);
    }
    return standbyChats
      .filter((standbyChat) => {
        const isClientNameMatchs =
          typeof standbyChat.cliente === "string" &&
          standbyChat.cliente
            .toLowerCase()
            .includes(textToFilterStandbyChats.toLowerCase());

        const isClientTelephoneMatchs =
          typeof standbyChat.telefone === "string" &&
          standbyChat.telefone
            .toLowerCase()
            .includes(textToFilterStandbyChats.toLowerCase());

        const isSomeMessageMatchs = !!handleSearchMessages(
          standbyChat,
          textToFilterStandbyChats,
        );
        return (
          isClientNameMatchs || isSomeMessageMatchs || isClientTelephoneMatchs
        );
      })
      .sort(orderByArrival);
  }, [
    textToFilterStandbyChats,
    standbyChats,
    tabFilterStandbyChatSelected,
    filterOrderStandbyChat,
    orderByMessage,
    orderByArrival,
    handleSearchMessages,
  ]);
  const numberOfStandbyChatsWithUnreadedMessages = useMemo(() => {
    return standbyChats.filter((standbyChat) => Boolean(standbyChat.qtdmessage))
      .length;
  }, [standbyChats]);

  //tabs
  const tabs = useMemo(() => {
    let regularChatsTab = {
      id: "regularChatTab",
      qtdChats: 0,
      qtdMessages: 0,
      icon: <Messages variant="Outline" />,
    };
    let standByChatsTab = {
      id: "standByChatsTab",
      qtdChats: 0,
      qtdMessages: 0,
      icon: <DirectboxReceive variant="Outline" />,
    };
    if (Array.isArray(regularChats)) {
      regularChatsTab.qtdChats = regularChats.length;
      regularChatsTab.qtdMessages = regularChats.reduce(
        (acc, current) => acc + current.qtdmessage,
        0,
      );
    }
    if (Array.isArray(standbyChats)) {
      standByChatsTab.qtdChats = standbyChats.length;
      standByChatsTab.qtdMessages = standbyChats.reduce(
        (acc, current) => acc + current.qtdmessage,
        0,
      );
    }

    return [regularChatsTab, standByChatsTab];
  }, [regularChats, standbyChats]);
  const [tabSelected, setTabSelected] = useState("regularChatTab");

  //funções
  function determineTypeName(fileExtension, valueDefault) {
    switch (fileExtension.toLowerCase()) {
      case "jpeg":
      case "png":
      case "webp":
      case "jpe":
      case "gif":
      case "bmp":
      case "jpg":
        return { type: "image", nameType: "Imagem" };
      case "pdf":
      case "zip":
      case "xls":
      case "xml":
      case "xlsx":
      case "xlsm":
      case "txt":
      case "doc":
      case "docx":
      case "ppt":
      case "pptx":
      case "ppsx":
        return { type: "document", nameType: "Arquivo" };
      case "wav":
      case "mp3":
      case "ogg":
      case "aac":
      case "m4a":
      case "amr":
      case "opus":
      case "mpeg":
        return { type: "audio", nameType: "Aúdio" };
      case "m4v":
      case "mp4":
        return { type: "video", nameType: "Vídeo" };
      default:
        return { type: "document", nameType: "Arquivo" };
    }
  }
  function handleSearchMessages(atd, searchChats) {
    let canSearch = false;
    let message = "";
    let verifyMsg = false;

    const getIconAndMessageForMedia = (lastMsg) => {
      const [thumbnail, captionRaw, url, size] = lastMsg.message.split("~¿");
      let cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
      let caption = (
        cleanCaption === "null" || !cleanCaption
          ? ""
          : captionRaw.replace(/¿/gi, "")
      )
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
        .replaceAll("\n", "")
        .replaceAll('"}', "")
        .replaceAll("\\n", "")
        .replaceAll("\r", "")
        .replace(/_(.*?)_/g, "$1");

      if (url) {
        const [pathWithoutExtension, extensionRaw] = url.split(".");
        const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
        const { type, nameType } = determineTypeName(extension, "document");
        let checkMsg =
          type === "audio"
            ? false
            : caption.toLowerCase().includes(searchChats.toLowerCase());

        return checkMsg;
      }

      return false;
    };

    if (messages[atd.idatendimento]) {
      const allMsg = messages[atd.idatendimento];
      for (const msgs of allMsg) {
        switch (msgs.typemsg) {
          case "0":
            let mensagem_tratada = msgs.message.replace(/¿/gi, "\n");
            message = mensagem_tratada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\n", "")
              .replaceAll("\\r", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");
            verifyMsg = message
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          case "1": {
            verifyMsg = getIconAndMessageForMedia(msgs);
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;
          }

          case "2": {
            const [rawText, url] = msgs.message
              .replace(/§/gi, "\r\n")
              .split("~¿");
            const messageSeparada = rawText
              .replace(/¿¿/gi, "")
              .replace(/¿/gi, "")
              .trim();

            const editmsg = messageSeparada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");

            message = editmsg.toLowerCase().includes(searchChats.toLowerCase());

            if (url && url !== "null" && url !== "undefined") {
              const [pathWithoutExtension, extensionRaw] = url.split(".");
              const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
              const { type, nameType } = determineTypeName(
                extension,
                "document",
              );

              if (type === "audio") {
                message = false;
              }
            }

            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;
          }

          case "4":
            let infosLocation = msgs.message.split("~¿");

            message = `${infosLocation[1]} ${infosLocation[0]}`
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          case "11":
            const cleanedJsonString = msgs.message.replace(
              /\\(?!["\\/bfnrtu])/g,
              "",
            );
            const contactInfo = JSON.parse(
              cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
            );

            message = contactInfo.name.formatted_name
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          default:
            break;
        }
      }
    }

    return canSearch;
  }
  const onSearchInCall = (call) => {
    setSelectedChat(call);
    setOpenSearch(true);
  };
  const onAnnotationCall = (event, callToAddAnnotation) => {
    const cdrid = callToAddAnnotation.idatendimento;
    const number = callToAddAnnotation.telefone;
    const cliente = callToAddAnnotation.cliente;
    ViewAnotations(event, number, cliente, cdrid);
  };
  const onTransferCall = (event, callToTransfer) => {
    const cdrid = callToTransfer.idatendimento;
    const serverid = callToTransfer.serverid;
    const iduser = callToTransfer.monuser;
    const number = callToTransfer.telefone;

    changeDisplayTransfer(event, cdrid, serverid, iduser, number);
  };
  const onEndCall = (callToEnd) => {
    const cdrid = callToEnd.idatendimento;
    const serverid = callToEnd.serverid;
    const iduser = callToEnd.monuser;
    changeDisplayByeChat(cdrid, serverid, iduser, infoUsers);
    setSelectedChat(null);
    setMonitorMessage([]);
    if (parseInt(callToEnd.idmidia) === 3) {
      dispatch(deleteEmailMsg(cdrid));
    }
  };
  const handleChangeOrderFilterStandbyChats = (type) => {
    setFilterOrderStandbyChat(type);
  };
  const handleChangeOrderFilterRegularChats = (type) => {
    setFilterOrderRegularChat(type);
  };
  const handleOpenOrderFilterRegularChat = () => {
    setOpenOrderFilterRegularChats(true);
  };
  const handleCloseOrderFilterRegularChat = () => {
    setOpenOrderFilterRegularChats(false);
  };
  const changeTabFilterRegularChat = (tabSelected) => {
    setTabFilterRegularChatSelected(tabSelected);
  };
  const changeTabFilterStandbyChat = (tabSelected) => {
    setTabFilterStandbyChatSelected(tabSelected);
  };
  const onSearch = (textToSearch) => {
    if (tabSelected === "regularChatTab") {
      setTextToFilterRegularChats(textToSearch);
    }
    if (tabSelected === "standByChatsTab") {
      setTextToFilterStandbyChats(textToSearch);
    }
  };
  const handleChangeTab = (tabInformation) => {
    setTabSelected(tabInformation.id);
  };

  return {
    regularChats,
    filteredRegularChats,
    standbyChats,
    filteredSatndbyChats,
    tabs,
    tabSelected,
    messages,
    infoUsers,
    tabFilterRegularChatSelected,
    tabFilterStandbyChatSelected,
    numberOfRegularChatsWithUnreadedMessages,
    numberOfStandbyChatsWithUnreadedMessages,
    openOrderFilterRegularChats,
    filterOrderRegularChat,
    filterOrderStandbyChat,
    textToFilterRegularChats,
    textToFilterStandbyChats,
    handleChangeTab,
    onSearch,
    changeTabFilterRegularChat,
    changeTabFilterStandbyChat,
    handleCloseOrderFilterRegularChat,
    handleOpenOrderFilterRegularChat,
    handleChangeOrderFilterRegularChats,
    handleChangeOrderFilterStandbyChats,
    onEndCall,
    onTransferCall,
    onAnnotationCall,
    onSearchInCall,
  };
};
